import axios from "src/service/axios_c";
import Quote from "@system/config/quote";
import Base from "./Base";
import quoteDetailAPICallResponseMaker from "src/service/QuoteDetailAPICall/quoteDetailAPICallResponseMaker";
import responseMaker from "src/service/QuoteAPICall/responseMaker";
import storeInUse from "../storeWire";
import Helper from "src/support/Helper";
import { __remove, __set } from "src/store/axios_indicator";

class QuoteDetailAPICall extends Base {
    submittedQuoteList = async (params = {}) => {
        let res = { count: 0, records: [] };
        await this.axiosCall(Quote.QUOTE_SUBMITTED_LIST, params, 'POST', true).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                if (resHer.data.data) {
                    if (resHer.data.data?.payload?.rows && resHer.data.data?.payload?.rows.length > 0) {
                        resHer.data.data?.payload?.rows.forEach(element => {
                            element['isLoad'] = false
                        });
                    }
                    res = {
                        count: resHer.data.data?.payload.rowCount,
                        records: resHer.data.data?.payload?.rows
                    };
                }
            }
        });
        return res;
    };

    getHeaderDetail = async (quoteNumber, quoteProvisionalNumber) => {
        let res = {};
        const baseUrl = `${Quote.QUOTE_SUBMITTED_DETAIL_SHORT_INFORMATION}`
        let url = quoteNumber ? `${baseUrl}?quoteNumber=${quoteNumber}` : "";

        url = (quoteProvisionalNumber && Helper.valueIsNotNull(quoteProvisionalNumber)) ?
            url ? `${url}&quoteProvisionalNumber=${quoteProvisionalNumber}` : `${baseUrl}?quoteProvisionalNumber=${quoteProvisionalNumber}`
            : url;

        await this.axiosCall(url, {}, 'GET', true).then((resHer) => {
            res = resHer.data.data;
        });

        let result = await new quoteDetailAPICallResponseMaker(res);
        result = await result.process();
        return result.run().get()
    };

    getLineItemsDetail = async (params = {}) => {
        let res = {};
        let failed = false;
        await this.axiosCall(Quote.QUOTE_SUBMITTED_DETAIL_LIST_BY_STATUS, params, 'POST', true).then((resHer) => {
            try {
                res = resHer.data?.data?.quoteHeaderDetails;
            } catch (e) {
                failed = true;
            }
        });

        if (failed === true) {
            if (storeInUse !== undefined && storeInUse) {
                let storeIn = storeInUse.getState();
                return storeIn.entities.model_QuoteDetail;
            }
        }
        let result = await new quoteDetailAPICallResponseMaker(res);
        result = await result.process(params);
        return result.run().get()
    };
    searchQuote = async (params = {}) => {
        let res = {};
        await this.axiosCall(Quote.QUOTE_SUBMITTED_DETAIL_LIST_WITH_STATUS, params, 'POST', true).then((resHer) => {
            res = resHer.data;
        });
        let result = await new responseMaker(res);
        result = await result.process();
        return result.run().get()
    };

    getSubmittedQuoteExportUrl = async (params = {}) => {
        let res = {};
        __set('EXPORT_URL')
        await this.axiosCall(Quote.SUBMITTED_QUOTE_EXPORT, params, 'POST', false, true).then((resHer) => {
            res = resHer.data;
            const url = window.URL.createObjectURL(new Blob([resHer.data]));
            const link = document.createElement('a');
            link.href = url;
            let _fileName = params.quoteNumber ? params.quoteNumber : params.provisionalId;
            link.setAttribute('download', 'Quotes_' + _fileName + '.' + params.fileType);
            document.body.appendChild(link);
            link.click();
        });
        __remove('EXPORT_URL')
        return res;
    };

    getApprovedQuotesList = async(params) => {
        let res = ''
        await this.axiosCall(Quote.APPROVED_QUOTE_SEARCH, params, 'POST').then((resHer) => {
            res = resHer.data.data && resHer.data.data
        }).catch((e) => {
            console.log(e)
            res = false
        });
        return res;
    }

    axiosCall = async (url, data = {}, method = 'post', skipParams = false, isBlob = false) => {
        data = await this.mergeDataWithBase(data);
        let config = {
            method: method,
            url: url,
            headers: Helper.getCommonHeader(method),
            data: data
        };
        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        if (isBlob) {
            config.responseType = 'blob';
        }
        return axios(config);
    };
    mergeDataWithBase = async (data) => {
        return {
            ...data
        };
    };
}

export default QuoteDetailAPICall;